import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProcessoStatusService } from '../../../services/processo-status.service';

@Component({
  selector: 'app-processo-status-list',
  templateUrl: './processo-status-list.component.html',
  styleUrls: ['./processo-status-list.component.scss']
})
export class ProcessoStatusListComponent extends BaseListComponent<any> implements OnInit {

  statusList: any[];

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ProcessoStatusService,
  ) {
    super();
  }

  ngOnInit() {
    this.loading();
    this.initLoadDataTable();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.statusList = res;
        this.loaded();
      })
    );
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}
